
export type Project = {
    UniqueCode: string;
    SupportedLanguages: Array<string>;
    BaseUrl: string;
    CssVersion?: string;
    Name: string;
    ApiSettings?: {
        UserData?: {
            CustomPropertiesHandling?: 'REPLACE_ALL' | 'KEEP_MISSING'
        }
    }
}

export function useGlobalProject(): Project {
    return getGlobalProject();
}

export function getGlobalProject(): Project {
    /** @ts-ignore */
    return window.auth.project as Project;
}

export function useDefaultLanguage(): string {
    return getDefaultLanguage();
}

export function getDefaultLanguage(): string {
    const p = getGlobalProject() || { SupportedLanguages: [] } as Project;

    return p.SupportedLanguages[0];
}